module.exports = __webpack_public_path__ + "img/eight8Blue.0f5951b9.jpg";